import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { IntrospectionFragmentMatcher } from "apollo-cache-inmemory";
const { coreURI, evotingIntrospectionQueryResultData } = require(process.env
  .VUE_APP_ENV === "PRODUCTION"
  ? "./config.prod"
  : "./config");

// Core Service Apollo Clients

const coreLink = new HttpLink({
  uri: coreURI,
  credentials: "include",
});

// Evoting Service Apollo Clients
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: evotingIntrospectionQueryResultData,
});

export const coreClient = new ApolloClient({
  link: coreLink,
  cache: new InMemoryCache({ fragmentMatcher }),
});
